'use es6';

import Raven from 'raven-js';
function captureException(err) {
  console.error(err);
  if (err.xhr || err.realXHR) {
    return;
  }
  Raven.captureException(err);
}
export default (() => next => action => {
  const {
    type,
    payload
  } = action;
  if (type && type.indexOf('_FAILED') > 0 && payload && payload.error) {
    captureException(payload.error);
  }
  if (typeof action === 'function') {
    const promise = next(action);
    return promise && promise.catch && promise.catch(err => {
      captureException(err);
      throw err;
    });
  }
  try {
    return next(action);
  } catch (err) {
    captureException(err);
    throw err;
  }
});